module.exports = __webpack_public_path__ + "img/send-bitcoin.69d2015c.svg";